export const UPDATE_OKTA_GATE = `
  mutation UpdateOktaGate($input: UpdateOktaGateInput!) {
    updateOktaGate(input: $input) {
      oktaGate {
        ssoEnabled
        orgName
        clientId
        clientSecretProvided
        reauthenticationDuration
        initiateUrl
        callbackUrl
        logoutUrl
      }
    }
  }
`;

export const OKTA_GATE = `
  query {
    oktaGate {
      ssoEnabled
      orgName
      clientId
      clientSecretProvided
      reauthenticationDuration
      initiateUrl
      callbackUrl
      logoutUrl
    }
  }
`;
